import { defineComponent as _defineComponent } from 'vue'
import { BaseCell, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  title: string;
  subtitle: string;
  color: string;
  align?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductNameCell',
  props: {
    title: null,
    subtitle: null,
    color: null,
    align: { default: 'left' }
  },
  setup(__props: any) {

const { color } = __props as { title: string, subtitle: string, color: string, align: string };



return { __sfc: true,color, BaseCell, BaseText, NebraskaColors }
}

})